import en from '../../../lang/en-us';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { sendPhoneOTP, getTrackStatus } from '../../../redux-store/actions/nct';
import { useEffect, useState } from 'react';
import moment from 'moment';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { TableCellParams, TableColumn } from '../../../lib/DataTable/types';
import { TableWithCollapse } from '../../../lib/DataTable';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { INPROGRESS, SUCCESS, REJECTED } from '.';

const getStatus = (value: string) => {
    const uppercaseValue = (value || '').toUpperCase();
    if (uppercaseValue === 'COMPLETED' || uppercaseValue === 'SUCCESS') {
        return SUCCESS;
    }
    if (uppercaseValue === 'PENDING' || uppercaseValue === 'ACCEPTED') {
        return INPROGRESS;
    }
    if (uppercaseValue === 'ERROR' || uppercaseValue === 'ERRORS') {
        return REJECTED;
    }
    return value;
};

const SUCCESSRESPONSE = 'Success';

const PENDINGRESPONSE = 'Pending';

const ERRORRESPONSE = 'errors';

const rtaResponses = [SUCCESSRESPONSE, PENDINGRESPONSE, ERRORRESPONSE];

const { dashboard, trackStatus } = en;

const collapseColumn: TableColumn = {
    field: 'status',
    headerName: 'STATUS',
    width: 100,
    renderCell: ({ row, value, collapse, setCollapse }) => {
        return (
            <>
                <div
                    style={{
                        color: 'white',
                        padding: 5,
                        textAlign: 'center',
                        borderRadius: 10,
                        background:
                            row.status === 'Success'
                                ? '#2E7D32'
                                : row.status === 'In Progress'
                                ? '#E65100'
                                : '#C62828',
                    }}
                >
                    {value}
                </div>
                {value === 'Rejected' && (
                    <span aria-label="expand row" onClick={() => setCollapse(!collapse)}>
                        {collapse ? null : (
                            <div
                                className="track-inner-collapse"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '10px',
                                        lineHeight: '13px',
                                        fontFamily: 'Montserrat-Bold',
                                        cursor: 'pointer',
                                    }}
                                >
                                    View Reason
                                </span>
                                <KeyboardArrowDownIcon />
                            </div>
                        )}
                    </span>
                )}
            </>
        );
    },
};

const trackStatusColumns: TableColumn[] = [
    { field: 'Sno', headerName: 'S NO.', width: 70 },
    { field: 'amcName', headerName: 'Fund House', width: 280 },
    { field: 'folio', headerName: 'FOLIO', width: 200 },
    { field: 'createdDate', headerName: 'DATE', width: 150 },
];

const getColumns = (requestType: string, tableColumns: TableColumn[]) => {
    switch (requestType) {
        case 'FATCA_CHANGE':
            return [
                { field: 'Sno', headerName: 'S NO.', width: 70 },
                { field: 'pan', headerName: 'PAN', width: 70 },
                { field: 'createdDate', headerName: 'DATE', width: 150 },
                collapseColumn,
            ];
        case 'UPDATE_FORM15_G_H':
            return [
                { field: 'Sno', headerName: 'S NO.', width: 70 },
                { field: 'amcName', headerName: 'Fund House', width: 280 },
                { field: 'createdDate', headerName: 'DATE', width: 150 },
                collapseColumn,
            ];
        case 'FOLIO_CONSOLIDATION':
            return [
                { field: 'Sno', headerName: 'S NO.', width: 70 },
                { field: 'amcName', headerName: 'Fund House', width: 280 },
                { field: 'targetFolio', headerName: 'Target Folio', width: 200 },
                { field: 'sourceFolio', headerName: 'Source Folio', width: 200 },
                collapseColumn,
            ];
        default:
            return [...tableColumns, collapseColumn];
    }
};

function TrackStatusNctType(props: any) {
    const [trackList, setList] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [nct, setNct] = useState<string>('');
    const [requestType, setType] = useState('');
    const [transactionId, setTransaction] = useState('');
    const { tableRows, tableColumns } = useTableWithCollapse({
        rows: trackList,
        columns: trackStatusColumns,
        loading,
    });
    const { transactionId: reqId = '' } = props.match.params || {};
    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            const { pan, pekrn, mobile } = props;
            try {
                let response: any = await props.getTrackStatus({
                    pan,
                    pekrn,
                    reqId,
                    mobile,
                });
                const { requests } = response.body;
                const {
                    requestTypeDesc,
                    rtaResponse,
                    requestTime,
                    reqId: transactionId,
                    requestType,
                } = requests[0];
                setType(requestType);
                const formated = Object.keys(rtaResponse)
                    .map((ele: string) => {
                        const data = rtaResponse[ele];
                        return data.map((item: any, ind: number) => {
                            return {
                                ...item,
                                amcName: item.amcName || 'Not Available',
                                folio: item.folio || item.targetFolio || 'Not Available',
                                createdDate: moment(requestTime).format('DD/MM/YYYY'),
                                pan: props.pan || props.pekrn,
                                status: getStatus(ele),
                                message: item.message || '',
                            };
                        });
                    })
                    .flat()
                    .map((item, ind: number) => ({
                        Sno: (ind + 1).toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false,
                        }),
                        ...item,
                    }));
                setLoading(false);
                setList(formated);
                setNct(requestTypeDesc);
                setTransaction(transactionId);
            } catch (err: any) {
                alert(err.message);
                setLoading(false);
            }
        }
        fetchData();
    }, [reqId]);

    const _renderCollapse = ({ row, setCollapse }: TableCellParams) => {
        return (
            <div
                className="track-inner-collapsed-content"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                }}
            >
                <p>{row.message}</p>
                <a onClick={() => setCollapse(false)}>
                    Hide <img src="/images/down-arrow-small.svg" alt="" />
                </a>
            </div>
        );
    };
    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => props.history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="" />
                </a>
                {dashboard.dashboardLeft.link4}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table track-status-inner-table">
                    <div className="track-inner-search">
                        {/* <SearchInput
                            darkmode={true}
                            placeholder={trackStatus.searchWithTransaction}
                        /> */}
                        <div className="track-search-info">
                            <p>
                                {trackStatus.serviceRequestType} : <span>{nct}</span>
                            </p>
                            <p>
                                TRANSACTION ID : <span>{transactionId}</span>
                            </p>
                        </div>
                    </div>
                    <div
                        className="curved-table-content"
                        tabIndex={0}
                        aria-label="Track status request list"
                    >
                        {!!trackList.length || loading ? (
                            <TableWithCollapse
                                renderCollapse={_renderCollapse}
                                columns={getColumns(requestType, tableColumns)}
                                rows={tableRows}
                            />
                        ) : (
                            <NoFoliosFound info={'No Request Found'} />
                        )}
                    </div>
                </div>
                <div className="curved-bg-content-inner-bottom"></div>
            </div>
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { getPortfolio, sendPhoneOTP, getTrackStatus },
)(TrackStatusNctType);
